import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../api/axiosConfig";
import signOut from "../../functions/userIdentity/signOut";

// Action Types
export const SEND_ANALYTIC_EVENT = "SEND_ANALYTIC_EVENT";

// Thunk Action Creator
export const sendEvent = createAsyncThunk(
    "api/Analytics/sendEvent",
    async (json, { dispatch }) => {

        await axios.post(
            `${import.meta.env.VITE_PUBLIC_DOMAIN}Analytics/sendEvent`,
            {
                Name: json.name,
                Category: json.category,
                Feature: json.feature ? json.feature : '',
                CustomParams: json.customParams ? json.customParams : '',
            },
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        )
            .then(response => {
                dispatch({ type: SEND_ANALYTIC_EVENT, payload: response.data });
            })
            .catch(error => {
                dispatch({ type: SEND_ANALYTIC_EVENT, payload: error });
            });
    }
);

export const setMobileProperties = createAsyncThunk(
    "api/Analytics/setMobileProperties",
    async (json, { dispatch }) => {

        await axios.post(
            `${import.meta.env.VITE_PUBLIC_DOMAIN}Analytics/setMobileProperties`,
            {
                Platform: json.platform,
                Type: json.type,
                Width: json.width,
                Height: json.height,
                Dpi: json.dpi
            },
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        )
            .then(response => {
                dispatch({ type: SEND_ANALYTIC_EVENT, payload: response.data });
            })
            .catch(error => {
                dispatch({ type: SEND_ANALYTIC_EVENT, payload: error });
            });
    }
);